import { queryOptions } from '@tanstack/vue-query'
import { getAccessToken } from './get-access-token'

export const AUTH_TOKEN_QUERY_KEY = ['authToken'] as const

export const authTokenQueryOptions = queryOptions({
  queryKey: AUTH_TOKEN_QUERY_KEY,
  queryFn: getAccessToken,
  staleTime: 5000,
  gcTime: 5000,
})
